import { render, staticRenderFns } from "./ModalItemProductEdit.vue?vue&type=template&id=dde6673c&scoped=true"
import script from "./ModalItemProductEdit.vue?vue&type=script&lang=ts"
export * from "./ModalItemProductEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde6673c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dde6673c')) {
      api.createRecord('dde6673c', component.options)
    } else {
      api.reload('dde6673c', component.options)
    }
    module.hot.accept("./ModalItemProductEdit.vue?vue&type=template&id=dde6673c&scoped=true", function () {
      api.rerender('dde6673c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalItemProductEdit.vue"
export default component.exports